import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { utilizationDetailUpdateApi } from '../apiService';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus, numberWithCommas, formatCycles } from '../../../utils';
import moment from 'moment';
import { NoRecordFound, PageLoader } from '../../../shared_elements';
import { displayDateFormatShort } from '../../../constants';
import InfoIcon from '@mui/icons-material/Info';
import { trackActivity } from '../../../utils/mixpanel';


const ViewUtilization = ({ onToggleModal, item, leaseSlug }) => {

    const [utilDetail, setUtilDetail] = useState([])
    const [isLoading, setLoading] = useState(false);
    const utilAssetData = utilDetail?.assets
    const formatNumber = (value) => value !== null && value !== undefined && value !== '' ? (typeof value === 'string' && value.includes(':') ? value : numberWithCommas(value)) : '--';
    const formatCycleNumber = (value) => value !== null && value !== undefined && value !== '' ? (typeof value === 'string' && value.includes(':') ? value : formatCycles(value)) : '--';

    useEffect(() => {
        getUtilizationDetailUpdateApi()
    }, [])

    const getUtilizationDetailUpdateApi = () => {
        setLoading(true);
        globalGetService(utilizationDetailUpdateApi(leaseSlug, item?.master_slug))
            .then(response => {
                if (checkApiStatus(response)) {
                    setLoading(false);
                    setUtilDetail(response?.data?.data?.details);
                } else {
                    setLoading(false);
                }
            })

    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `View Utilization`, page_type: page_type, })
    }

    return (
        <>
            <Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' maxWidth="lg" fullWidth open={true} >
                <DialogTitle sx={{ m: 0, p: 2, pl:3  }} className='dialog-header' id="customized-dialog-title">
                    View Utilization
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2} sx={{ padding: "4px", display: 'flex', flexDirection: 'row' }}>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                value={utilDetail?.start_date || null}
                                size='small'
                                label="Start Date"
                                variant="outlined"
                                fullWidth
                                disabled
                                slotProps={{ inputLabel: { shrink: true } }} />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                value={utilDetail?.end_date || null}
                                size='small'
                                label="End Date"
                                variant="outlined"
                                fullWidth
                                disabled
                                slotProps={{ inputLabel: { shrink: true } }} />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                value={utilDetail?.utilization_type || null}
                                size='small'
                                label="Utilization Type"
                                variant="outlined"
                                fullWidth
                                disabled
                                slotProps={{ inputLabel: { shrink: true } }} />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                value={utilDetail?.unit_of_measure || null}
                                size='small'
                                label="Unit of Measure"
                                variant="outlined"
                                fullWidth
                                disabled
                                slotProps={{ inputLabel: { shrink: true } }} />
                        </Grid>
                        <Grid size={{ md: 3, sm: 3, xs: 3 }}>
                            <TextField
                                value={utilDetail?.escalation_region || null}
                                size='small'
                                label="Region of Operation"
                                variant="outlined"
                                fullWidth
                                disabled
                                slotProps={{ inputLabel: { shrink: true } }} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ display: 'flex', flexDirection: 'row', }}>
                        <Grid size={{ md: 12, xs: 12, sm: 12 }}>
                            <div style={{ overflowY: 'auto', height: '240px', marginTop: "5px", padding: '0px 0px 0px 3px' }}>
                                <TableContainer className="lease-detail-table" component={Paper}>
                                    <Table className="mui-table-format" stickyHeader sx={{ overflow: 'auto',  }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ minWidth: '170px' }}> Assembly </TableCell>
                                                <TableCell sx={{ minWidth: '120px' }}> Start Date </TableCell>
                                                <TableCell sx={{ minWidth: '120px' }}> End Date </TableCell>
                                                <TableCell align="center" sx={{ minWidth: '100px' }}> TSN as Of </TableCell>
                                                <TableCell align="center" sx={{ minWidth: '100px' }}> CSN as Of </TableCell>
                                                <TableCell sx={{ minWidth: '180px' }}> Unit of Measure </TableCell>
                                                <TableCell align="center" sx={{ minWidth: '120px' }}> BH <Tooltip placement='top' title="Block Hours"><InfoIcon sx={{ cursor: 'pointer', fontSize: 'small' }} color="primary" fontSize="small" /></Tooltip></TableCell>
                                                <TableCell align="center" sx={{ minWidth: '140px' }}> Flight Hours </TableCell>
                                                <TableCell align="center" sx={{ minWidth: '140px' }}> Flight Cycle </TableCell>
                                                <TableCell align="center" sx={{ minWidth: '120px' }}> DeRate </TableCell>
                                                <TableCell align="center" sx={{ minWidth: '120px' }}> EGTM <Tooltip placement='top' title="EGT Margin"><InfoIcon sx={{ cursor: 'pointer', fontSize: 'small' }} color="primary" fontSize="small" /></Tooltip></TableCell>
                                                <TableCell sx={{ minWidth: '140px' }}> Location</TableCell>
                                                <TableCell sx={{ minWidth: '130px' }}> Remarks</TableCell>
                                                <TableCell sx={{ minWidth: '140px' }}> Serviceablity</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {utilAssetData?.length > 0 ? utilAssetData?.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{item?.asset_name || "--"}
                                                        <br />
                                                        <span style={{ fontSize: '11px', color: '#8b7777', display: "inline" }}>{item?.last_utilization_date ? moment(item.last_utilization_date).format(displayDateFormatShort) : ''}</span>
                                                    </TableCell>
                                                    <TableCell >{item?.period_start_date ? moment(item.period_start_date).format(displayDateFormatShort) : "--"}</TableCell>
                                                    <TableCell >{item?.period_end_date ? moment(item.period_end_date).format(displayDateFormatShort) : "--"}</TableCell>
                                                    <TableCell align="center">{formatNumber(item?.tsn)}</TableCell>
                                                    <TableCell align="center">{formatCycleNumber(item?.csn)}</TableCell>
                                                    <TableCell >{item?.unit_of_measure || '--'}</TableCell>
                                                    <TableCell align="center">{formatNumber(item?.entered_block_hours)}</TableCell>
                                                    <TableCell align="center">{formatNumber(item?.unit_of_measure === "Time Format" ? item?.entered_hours : item?.hours)}</TableCell>
                                                    <TableCell align="center">{formatCycleNumber(item?.unit_of_measure === "Time Format" ? item?.entered_cycles : item?.cycles)}</TableCell>
                                                    <TableCell align="center">{formatNumber(item?.derate)}</TableCell>
                                                    <TableCell align="center">{formatNumber(item?.egtm)}</TableCell>
                                                    <TableCell >{item?.asset_location || '--'}</TableCell>
                                                    <TableCell >{item?.remarks || '--'}</TableCell>
                                                    <TableCell >{item?.item?.serviceability || '--'}</TableCell>
                                                </TableRow>
                                            )) : (<NoRecordFound />)}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ marginRight: "15px" }}>
                    <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> Close </Button>
                </DialogActions>
                {isLoading ? <PageLoader /> : null}
            </Dialog>
        </>
    )
}

export default ViewUtilization
